import { ReactNode, createContext, useContext, useState } from 'react';

import { Alert } from './Alert';

interface AlertOptions {
  title: string;
  onSubmit: () => void;
  children: ReactNode;
  error?: string;
}

interface AlertContextValue {
  open: (options: AlertOptions) => void;
  close: () => void;
}

const AlertContext = createContext<AlertContextValue | null>(null);

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<AlertOptions | null>(null);

  const open = (options: AlertOptions) => setState(options);
  const close = () => setState(null);

  const handleSubmit = () => {
    state?.onSubmit();
    close();
  };

  return (
    <AlertContext.Provider value={{ open, close }}>
      {children}
      {state && (
        <Alert
          open={true}
          setClose={close}
          title={state.title}
          onSubmit={handleSubmit}
          error={state.error}
        >
          {state.children}
        </Alert>
      )}
    </AlertContext.Provider>
  );
};

export const useAlertContext = () => {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error('useAlertContext must be used within AlertProvider');
  return ctx;
};
